<template>
  <div
    :class="['mirrored', `mirrored--${data.imageOrientation}`]"
  >
    <div class="ui-container ui-container--small">
      <div
        v-for="(picture, index) in data.picture"
        :class="['mirrored__item', index === (data.picture.length - 1) ? 'mirrored__item--no-margin' : false]"
        :key="index"
      >
        <div class="m-item__image-cont">
          <a
            :href="picture.url"
            target="_blank"
            rel="noopener"
            v-if="picture.url !== '' && picture.url !== undefined"
          >
          </a>

          <BasePicture
            :data="picture"
            class="m-item__image"
            :lottieBg="'square'"
          />
        </div>

        <div class="m-item__text">
          <h3
            class="m-item__title"
            :class="picture.isAddress ? 'm-item__title--address' : false"
            js-anim="title"
            v-html="picture.mirroredTitle"
          >
          </h3>
          <div class="m-item__content" js-anim="text" v-html="picture.mirroredContent"></div>

          <BaseButtonFilled
            :data="picture"
            class="m-item__cta"
            v-if="picture.url !== '' && picture.url !== undefined"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BasePicture from '@/components/BasePicture';
import BaseButtonFilled from '@/components/BaseButtonFilled';


export default {
  name: 'mirrored',

  components: {
    BasePicture,
    BaseButtonFilled,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss">
@import "../styles/utils";

.mirrored {
  position: relative;
  padding: 20px 0 0;

  &__item {
    position: relative;
    width: 100%;
    margin-bottom: 80px;

    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-flow: row wrap;

    @include mq(ipadP) {
      margin-bottom: 160px;
    }

    &--no-margin {
      margin-bottom: 0;
    }
  }

  .m-item {
    &__image {
      @include aspect-ratio(1, 0.9);

      @include mq(mobileL) {
        @include aspect-ratio(1, 0.6);
      }

      @include mq(ipadP) {
        @include aspect-ratio(1, 0.9);
      }

      &-cont {
        position: relative;
        width: 100%;
        flex: 0 0 100%;

        @include mq(mobileL) {
          width: calc(100% - 40px);
          flex: 0 0 calc(100% - 40px);
        }

        @include mq(ipadP) {
          width: calc(50% - 80px);
          flex: 0 0 calc(50% - 80px);
        }

        a {
          display: block;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 3;
        }
      }
    }

    &__title {
      &--address {
        font-size: 1.3rem;
        line-height: 1.4em;

        @include mq(ipadP) {
          font-size: 2rem;
        }
      }
    }

    &__text {
      width: 100%;
      flex: 0 0 100%;

      padding: 0 20px;
      margin-top: 25px;

      @include mq(ipadP) {
        width: 50%;
        margin-top: 0;
        padding: 0;
        flex: 0 0 50%;
      }


      h3 {
        margin-bottom: 20px;
      }
    }

    &__cta {
      margin-top: 20px !important;
      position: relative;
      left: -20px;

      @include mq(ipadP) {
        left: auto;
        margin-top: 40px !important;
      }
    }
  }

  &--left {
    .mirrored__item:nth-child(odd) {
      .m-item__image-cont {
        order: 1;

        @include mq(mobileL) {
          margin-left: 40px;
        }

        @include mq(ipadP) {
          margin-left: 80px;
        }
      }

      .m-item__text {
        order: 2;

        @include mq(mobileL) {
          padding-left: 40px;
        }

        @include mq(ipadP) {
          padding: 0 80px;
        }
      }
    }

    .mirrored__item:nth-child(even) {
      .m-item__image-cont {
        @include mq(ipadP) {
          order: 2;
        }
      }

      .m-item__text {
        @include mq(mobileL) {
          padding-right: 40px;
        }

        @include mq(ipadP) {
          order: 1;

          padding: 0 80px;
        }
      }
    }
  }

  &--right {
    .mirrored__item:nth-child(odd) {
      .m-item__image {
        @include mq(ipadP) {
          order: 2;
        }
      }

      .m-item__text {
        @include mq(mobileL) {
          padding-right: 40px;
        }

        @include mq(ipadP) {
          padding: 0 80px;
          order: 1;
        }

        h3 {
          right: 0;
        }
      }
    }

    .mirrored__item:nth-child(even) {
      .m-item__image {
        @include mq(mobileL) {
          margin-left: 40px;
        }

        @include mq(ipadP) {
          margin-left: 80px;
          order: 1;
        }
      }

      .m-item__text {
        @include mq(mobileL) {
          padding-left: 40px;
        }

        @include mq(ipadP) {
          padding: 0 80px;
          order: 2;
        }

        h3 {
          left: 0;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.bigimage + .mirrored {
  padding-top: 0 !important;
}
</style>

